// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/UmbrellaChannel/index.css
// module id = 2576
// module chunks = 0